/**
 * CASESTUDY詳細
 */
import 'es6-promise/auto';
import 'picturefill';
import 'lazysizes';
import { breakpoint, containerID } from '@/_modules/utils/variables';
// vue
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalFooter from '@/_components/global-footer.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import EntryMv from '@/_components/entry-mv.vue';
import BgWhite from '@/_components/bg-white.vue';
import Related from '@/_components/related.vue';
import RelatedSp from '@/_components/related-sp.vue';
import CommonPlugin from '@/_modules/common/common-plugin'
Vue.use(CommonPlugin);

import scrollManager from '@/_modules/common/scrollManager';
import subBg from '@/_modules/common/subBg';
window.$scrollManager = scrollManager;

export default class AppNewsEntry {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppNewsEntry';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    new subBg();

    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        GlobalHeader,
        GlobalFooter,
        GlobalNavi,
        EntryMv,
        BgWhite,
        Related,
        RelatedSp
      },
      data() {
        return {
          ispc: false,
          isLoaded: false,
          isState: '',
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {
        $scrollManager.init();

        this.$nextTick(this.start);
      },
      methods: {
        start() {

          this.$_setRatio(this.$el.querySelectorAll('.p-casestudy__conWrap__galleryIframeWrap'));

          this.$store.commit('setShowCoverOut', false);
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        }
      }
    });
  }
}
